module.exports = __webpack_public_path__ + "1142e7e027879e1887f1516106e82631.svg";